/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OptionDto_Int32 } from '../models/OptionDto_Int32';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompantTypeService {

    /**
     * @returns OptionDto_Int32 OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppCompantTypeTenantTypesForCompanyCreate(): CancelablePromise<Array<OptionDto_Int32>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/compant-type/tenant-types-for-company-create',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
